import { useEffect } from 'react';
import { getSafeUserRequestContext } from '#shared/lib/context';
import { useDeferred } from '#shared/lib/hooks';

const BUTTERFLY_SRC = 'https://yastatic.net/s3/frontend/butterfly/latest/butterfly.js';

const BUTTERFLY_ATTRIBUTES: Record<string, string> = {
    id: 'yndxbug',
    position: 'left',
    'offset-x': '0',
    'offset-y': '0',
    'text-direction': 'ltr',
    'container-id': 'body',
    modules: 'ab',
    form: '',
    'data-data': '',
    'data-exp': '',
    'data-text': '',
    'bug-color-theme': 'light',
    'dnd-field': '',
    'html-field': '',
    'data-info': '',
    'console-methods': '',
    'data-additional-query-string': '',
    'data-external': '',
    screenshot: 'on',
    'allow-media-stream': 'on',
    'data-domain': 'yandex',
    'data-form-url': '',
    'has-virtual-keyboard': 'on',
    proxy: 'true',
    'proxy-domain': '',
    'exp-path': 'https://yandex.ru/ecoo',
};

export function ButterflyScript() {
    const deferred = useDeferred();
    const { isInternalYandexUser } = getSafeUserRequestContext();

    useEffect(() => {
        if (!deferred || !isInternalYandexUser) {
            return;
        }

        const script = document.createElement('script');

        script.src = BUTTERFLY_SRC;
        script.async = true;

        for (const [key, value] of Object.entries(BUTTERFLY_ATTRIBUTES)) {
            script.setAttribute(key, value);
        }

        document.body.appendChild(script);

        return () => {
            script.remove();
        };
    }, [deferred, isInternalYandexUser]);

    return null;
}
